module.exports = __webpack_public_path__ + "static/media/ic_proyectos_carretero_pin_seleccionado.939cc87a.svg";